import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/close.svg'
import _imports_1 from '../../assets/caprock/images/plus.svg'
import _imports_2 from '../../assets/caprock/images/minus.svg'


const _withScopeId = n => (_pushScopeId("data-v-64127afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row my-3 justify-content-center"
}
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "login-body company" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("h4", { style: {"color":"grey","font-family":"'Merriweather'"} }, " Partners "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-4 mb-4 font-grey" }, [
      /*#__PURE__*/_createTextVNode(" Each of the listed partners below will receive email with the registration link to complete the caprock Individual Application Form."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" The partners and the partnership account will not be activated unless all the partners have successfully completed and submitted their individual application form. ")
    ])
  ])
], -1))
const _hoisted_7 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_8 = { class: "table table-bordered w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_0
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  class: "text-right w-100",
  style: {"color":"#6B7A99"}
}
const _hoisted_19 = { class: "row my-3 justify-content-center" }
const _hoisted_20 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_21 = { class: "login-card" }
const _hoisted_22 = { class: "login-body company" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6 col-6" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_27 = { class: "col-md-6 col-6" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_30 = { class: "col-md-6 col-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_33 = {
  key: 0,
  class: "col-md-6 col-6"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Partner ")
], -1))
const _hoisted_35 = {
  class: "modal fade delete_partner",
  id: "delete_partner",
  role: "dialog"
}
const _hoisted_36 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_37 = {
  class: "modal-content",
  style: {"border":"1px solid grey","border-radius":"6px"}
}
const _hoisted_38 = { class: "modal-body mb-2" }
const _hoisted_39 = { class: "row mx-1 mt-1" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Removing partner will erase all details of this partner.")
], -1))
const _hoisted_41 = { class: "col-md-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.partners.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: partner.partner_id
                          }, [
                            _createElementVNode("td", _hoisted_10, _toDisplayString(index+1), 1),
                            _createElementVNode("td", null, _toDisplayString(partner['partner_name']), 1),
                            _createElementVNode("td", null, _toDisplayString(partner['partner_email']), 1),
                            _createElementVNode("td", null, _toDisplayString(partner['partner_phone_no']), 1),
                            _createElementVNode("td", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: ($event: any) => {_ctx.ask_delete(partner.partner_id);},
                                class: "btn-mobile btn"
                              }, _hoisted_14, 8, _hoisted_12)
                            ])
                          ]))
                        }), 128)),
                        (!_ctx.partners.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createTextVNode(" Do you want to add another partner "),
                    _createElementVNode("img", {
                      class: "pl-2 mr-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.show_form=1)),
                      style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                      src: _imports_1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.partners.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          ref: "partner_form",
          id: "partner_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_partner
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.partner_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.partner_name) = $event)),
                            placeholder: "i.e. Jonaten ",
                            class: "form-control selected-field",
                            name: "partner_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "partner_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.partner_email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.partner_email) = $event)),
                            placeholder: "i.e. email@address.com  ",
                            class: "form-control selected-field",
                            name: "partner_email",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.validateEmail]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "partner_email"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.partner_phone_no,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.partner_phone_no) = $event)),
                            placeholder: "i.e. 3539 000556  ",
                            class: "form-control selected-field",
                            name: "partner_phone_no",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.mobileField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "partner_phone_no"
                          })
                        ])
                      ]),
                      (_ctx.partners.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("img", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (this.show_form=0)),
                              style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                              src: _imports_2
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_34
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.delete_partner(_ctx.active_partner_id)))
                }, "Remove"),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal('delete_partner'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}